export default __webpack_public_path__ + "static/media/18146b42fccd9097.bad522b8a6c33808628cbe864b9d26bb.svg";